import { createApp } from 'vue'
import App from '@/user/App.vue'
import router from '@/user/router'
import store from '@/user/store'
import { createMetaManager, plugin as MetaPlugin } from 'vue-meta'
import I18nPlugin from '@/user/plugins/i18n.js'
import ValidatePlugin from '@/user/plugins/validate.js'
import GlobalPropertiesPlugin from '@/user/plugins/globalProperties.js'
import * as Kakao from 'kakao-sdk'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
import './assets/css/main.css'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(ValidatePlugin)
app.use(I18nPlugin)
app.use(GlobalPropertiesPlugin)
app.use(createMetaManager())
app.use(MetaPlugin)
router.isReady().then(() => app.mount('#app'))
Kakao.init(process.env.VUE_APP_KAKAO_JAVASCRIPT_APP_KEY)
console.log('version', process.env.VUE_APP_VERSION)
